var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 51.5,
    height: 51.5,
    rx: 25.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 51.5,
    height: 51.5,
    rx: 25.75,
    stroke: "#1FB16E",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.97 32.83C35.97 33.19 35.89 33.56 35.72 33.92C35.55 34.28 35.33 34.62 35.04 34.94C34.55 35.48 34.01 35.87 33.4 36.12C32.8 36.37 32.15 36.5 31.45 36.5C30.43 36.5 29.34 36.26 28.19 35.77C27.04 35.28 25.89 34.62 24.75 33.79C23.6 32.95 22.51 32.02 21.47 30.99C20.44 29.95 19.51 28.86 18.68 27.72C17.86 26.58 17.2 25.44 16.72 24.31C16.24 23.17 16 22.08 16 21.04C16 20.36 16.12 19.71 16.36 19.11C16.6 18.5 16.98 17.94 17.51 17.44C18.15 16.81 18.85 16.5 19.59 16.5C19.87 16.5 20.15 16.56 20.4 16.68C20.66 16.8 20.89 16.98 21.07 17.24L23.39 20.51C23.57 20.76 23.7 20.99 23.79 21.21C23.88 21.42 23.93 21.63 23.93 21.82C23.93 22.06 23.86 22.3 23.72 22.53C23.59 22.76 23.4 23 23.16 23.24L22.4 24.03C22.29 24.14 22.24 24.27 22.24 24.43C22.24 24.51 22.25 24.58 22.27 24.66C22.3 24.74 22.33 24.8 22.35 24.86C22.53 25.19 22.84 25.62 23.28 26.14C23.73 26.66 24.21 27.19 24.73 27.72C25.27 28.25 25.79 28.74 26.32 29.19C26.84 29.63 27.27 29.93 27.61 30.11C27.66 30.13 27.72 30.16 27.79 30.19C27.87 30.22 27.95 30.23 28.04 30.23C28.21 30.23 28.34 30.17 28.45 30.06L29.21 29.31C29.46 29.06 29.7 28.87 29.93 28.75C30.16 28.61 30.39 28.54 30.64 28.54C30.83 28.54 31.03 28.58 31.25 28.67C31.47 28.76 31.7 28.89 31.95 29.06L35.26 31.41C35.52 31.59 35.7 31.8 35.81 32.05C35.91 32.3 35.97 32.55 35.97 32.83Z",
    stroke: "#1FB16E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9992 18.5H29.1992M33.9992 18.5V23.3V18.5Z",
    stroke: "#1FB16E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCall);
export default __webpack_public_path__ + "static/media/iconCall.d05a02e8d4fd3d98afc91d62808a1d52.svg";
export { ForwardRef as ReactComponent };